import {
  partialRight,
  mapValues,
  chain,
  // chunk,
  findIndex,
  maxBy,
  minBy,
  groupBy,
  orderBy,
  meanBy,
  property,
  pick,
  values
} from 'lodash';
import * as Papa from 'papaparse';

import {
  RESET_ALL_ANALYSIS_DATA,
  SET_ANALYSIS_VIDEO_DATA,
  SET_ANALYSIS_HEATMAPS_DATA,
  SET_ANALYSIS_JOURNEYMAP_DATA,
  SET_ANALYSIS_AGGREGATE_JOURNEYMAP_DATA,
  SET_ANALYSIS_CIRCUMPLEX_DATA,
  SET_ANALYSIS_DATASET
} from './consts';

function keepWhitelistedKeys(...keys) {
  return object => pick(object, keys);
}

function toSeconds(value) {
  return value / 1000;
}

const mapWith = func => array => array.map(func);
// const sortWith = propertyName => array => array.sort((a, b) => a[propertyName] - b[propertyName]);

function compose(...funcs) {
  if (funcs.length === 0) {
    return arg => arg;
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce((a, b) => (...args) => a(b(...args)));
}

/**
 * All
 */

export const resetAllAnalysisData = () => {
  return {
    type: RESET_ALL_ANALYSIS_DATA
  };
};

export const setAnalysisDataSet = data => {
  return {
    type: SET_ANALYSIS_DATASET,
    dataSet: data
  };
};
/**
 * Video Analysis
 */
const setProjectAnalysisVideoData = video => {
  return {
    type: SET_ANALYSIS_VIDEO_DATA,
    video
  }
}

export const updateProjectAnalysisDataVideo = ( layerId ) => {
  return async (dispatch, getState, { apiClient }) => {
    const streaming = await apiClient.call('Streaming', 'url_request', { id: layerId });
    console.log(streaming);
    dispatch(setProjectAnalysisVideoData(streaming));
  };
}

// export const streamingURL = (layerId) => {
//   return async (dispatch, getState, { apiClient }) => {
//     const streaming = await apiClient.call(STIMULI_TAG, 'video', { layerId });
//   };
// };


/**
 * Heatmaps
 */

const setProjectAnalysisDataHeatmaps = heatmaps => {
  return {
    type: SET_ANALYSIS_HEATMAPS_DATA,
    heatmaps
  };
};
export const updateProjectAnalysisDataHeatmaps = (data, abstractTypeId, layerId, stimuliId) => {
  return (dispatch, getState) => {
    // Find data if already exists, update data & timestamp
    const currentHeatmaps = getState().analysis.data.heatmaps;
    const resultIndex = findIndex(currentHeatmaps, { stimuliId, layerId, abstractTypeId });

    // Not new data, update

    const mappedData = data.map(row => {
      return {
        x: row[0],
        y: row[1],
        value: row[2]
      };
    });

    if (resultIndex >= 0) {
      const result = currentHeatmaps[resultIndex];

      const newData = {
        ...result,
        data: mappedData,
        generationTimestamp: Math.round(new Date() / 1000)
      };

      dispatch(
        setProjectAnalysisDataHeatmaps(
          currentHeatmaps.map((heatmap, i) => {
            if (i === resultIndex) {
              return newData;
            }
            return heatmap;
          })
        )
      );
    } else {
      const newData = {
        stimuliId,
        layerId,
        abstractTypeId,
        opacity: 1,
        generationTimestamp: Math.round(new Date() / 1000),
        data: mappedData
      };
      dispatch(setProjectAnalysisDataHeatmaps([...currentHeatmaps, newData]));
    }
  };
};

// JourneyMap serialiseData
const serialiseData = data => {
  const receivedData = Papa.parse(data, {
    header: true,
    dynamicTyping: true,
    transform: (val, header) => (val === 'null' ? null : val)
  });

  // Sanitize
  receivedData.errors.forEach(key => {
    receivedData.data.splice(key.row, 1);
  });

  return receivedData;
};

// Journey Map verification (Catch error)
const errorChecker = dataToCheck => {
  const output = {
    dataError: true,
    canItBeRender: false,
    keyNameError: false
  };

  if (!dataToCheck || !dataToCheck.data || dataToCheck.data.length <= 1) {
    // DataError Error
    output.dataError = true;
    output.canItBeRender = false;
    output.keyNameError = false;
  } else if (
    dataToCheck.minX !== undefined &&
    dataToCheck.maxX !== undefined &&
    dataToCheck.minY !== undefined &&
    dataToCheck.maxY !== undefined &&
    dataToCheck.minSize !== undefined &&
    dataToCheck.maxSize !== undefined &&
    dataToCheck.minIntensity !== undefined &&
    dataToCheck.maxIntensity !== undefined
  ) {
    // Success
    output.canItBeRender = true;
    output.dataError = false;
    output.keyNameError = false;
  } else {
    // Keyname error
    output.keyNameError = true;
    output.canItBeRender = false;
    output.dataError = false;
  }
  return output;
};

/**
 * Participant JourneyMap
 */

const setProjectAnalysisDataJourneyMap = journeyMap => {
  return {
    type: SET_ANALYSIS_JOURNEYMAP_DATA,
    journeyMap // is an array
  };
};

const structureParticipantData = (data, participantId) => {
  const xKeyName = 'absolute_time'; // Time
  const yKeyName = 'Arousal'; //
  const sizeKeyName = 'Pupil'; // Size of the dot
  // const intensityKeyName = "Neutral"; // Valence / color intensity
  const minIntensityKey = 'Valence_negative';
  const maxIntensityKey = 'Valence_positive';

  // const fields = [xKeyName, yKeyName, sizeKeyName, minIntensityKey, maxIntensityKey];

  const sortedData = data.sort((a, b) => a[xKeyName] - b[xKeyName]);

  // by trial and error, we found out that around 100 points is visually ok in our ui.
  // TODO: make it configurable in the ui
  // const chunks = chunk(sortedData, Math.ceil(sortedData.length / sortedData.length));

  // const averagedData = chunks.reduce((accumulator, chunked) => {
  //   const chunkAveraged = {};

  //   fields.forEach(f => {
  //     chunkAveraged[f] = meanBy(chunked, f);
  //   });

  //   accumulator.push(chunkAveraged);
  //   return accumulator;
  // }, []);
  const averagedData = sortedData;

  const dataInfos = {
    participantId,
    minX: toSeconds(minBy(averagedData, xKeyName)[xKeyName]),
    maxX: toSeconds(maxBy(averagedData, xKeyName)[xKeyName]),
    minY: minBy(averagedData, yKeyName)[yKeyName],
    maxY: maxBy(averagedData, yKeyName)[yKeyName],
    minSize: minBy(averagedData, sizeKeyName)[sizeKeyName],
    maxSize: maxBy(averagedData, sizeKeyName)[sizeKeyName],
    minIntensity: -1 * maxBy(averagedData, minIntensityKey)[minIntensityKey],
    maxIntensity: maxBy(averagedData, maxIntensityKey)[maxIntensityKey],
    colorMin: {
      r: 158,
      g: 58,
      b: 38
    },
    colorMax: {
      r: 244,
      g: 209,
      b: 102
    },
    minSizeRadius: 0.3,
    maxSizeRadius: 7,
    canItBeRender: false,
    keyNameError: false,
    dataError: false
  };

  // Set total size
  dataInfos.totalSizeRadius = dataInfos.maxSizeRadius - dataInfos.minSizeRadius;
  dataInfos.totalSize = dataInfos.maxSize - dataInfos.minSize;

  // Add range
  dataInfos.xRange = dataInfos.maxX / 1000 - dataInfos.minX / 1000;
  dataInfos.yRange = dataInfos.maxY - dataInfos.minY;
  dataInfos.sizeRange = dataInfos.maxSize - dataInfos.minSize;
  dataInfos.sizeRadiusRange = dataInfos.maxSizeRadius - dataInfos.minSizeRadius;
  dataInfos.intensityRange = dataInfos.maxIntensity + Math.abs(dataInfos.minIntensity);

  dataInfos.sizeStep = dataInfos.sizeRange / 6;
  dataInfos.intensityStep = dataInfos.intensityRange / 10;

  let newData = {
    generationTimestamp: Math.round(new Date() / 1000),
    data: averagedData.map(val => {
      return {
        x: val[xKeyName] / 1000,
        y: val[yKeyName],
        size: val[sizeKeyName],
        intensity: val[maxIntensityKey] - val[minIntensityKey]
      };
    })
  };

  newData = Object.assign(dataInfos, newData);

  Object.assign(newData, errorChecker(newData));

  return newData;
};

const structureAggregateData = data => {
  const xKeyName = 'absolute_time'; // Time

  const groupByEvent = groupBy(data.data, 'event');
  const eachEventMinTime = [];
  const yKeyName = 'Arousal'; //
  const sizeKeyName = 'Pupil'; // Size of the dot
  // const intensityKeyName = "Neutral"; // Valence / color intensity
  const minIntensityKey = 'Valence_negative';
  const maxIntensityKey = 'Valence_positive';

  const eventKeys = Object.keys(groupByEvent);
  eventKeys.forEach(key => {
    // Get min time of each event
    eachEventMinTime.push(minBy(groupByEvent[key], val => val[xKeyName]));
  });

  // Order event by min time AND use the forEach(map) to get other values
  const eventsOrdered = orderBy(eachEventMinTime, xKeyName, 'asc').map((eventData, index) => {
    return {
      eventName: eventData.event,
      x: index + 1,
      y: meanBy(
        groupByEvent[eventData.event].filter(k => typeof k[yKeyName] === 'number'),
        yKeyName
      ),
      size: meanBy(
        groupByEvent[eventData.event].filter(k => typeof k[sizeKeyName] === 'number'),
        sizeKeyName
      ),
      intensity: meanBy(
        groupByEvent[eventData.event].filter(
          k => typeof k[minIntensityKey] === 'number' && typeof k[maxIntensityKey] === 'number'
        ),
        v => v[minIntensityKey] - v[maxIntensityKey]
      )
    };
  });

  // Define base result
  const result = {
    minX: 1,
    maxX: eventKeys.length + 1,
    minY: minBy(data.data, yKeyName)[yKeyName],
    maxY: maxBy(data.data, yKeyName)[yKeyName],
    minSize: minBy(data.data, sizeKeyName)[sizeKeyName],
    maxSize: maxBy(data.data, sizeKeyName)[sizeKeyName],
    minIntensity: -1 * maxBy(data.data, minIntensityKey)[minIntensityKey],
    maxIntensity: maxBy(data.data, maxIntensityKey)[maxIntensityKey],
    colorMin: {
      r: 158,
      g: 58,
      b: 38
    },
    colorMax: {
      r: 244,
      g: 209,
      b: 102
    },
    minSizeRadius: 0.3,
    maxSizeRadius: 17,
    canItBeRender: false,
    keyNameError: false,
    dataError: false,
    data: eventsOrdered
  };

  // Add more data base on existing result
  result.xRange = result.maxX - result.minX;
  result.yRange = result.maxY - result.minY;

  result.intensityRange = result.maxIntensity + Math.abs(result.minIntensity);
  result.intensityStep = result.intensityRange / 10;

  result.sizeRange = result.maxSize - result.minSize;
  result.sizeRadiusRange = result.maxSizeRadius - result.minSizeRadius;
  result.sizeStep = result.sizeRange / 6;
  result.totalSizeRadius = result.maxSizeRadius - result.minSizeRadius;
  result.totalSize = result.maxSize - result.minSize;

  // Check error
  Object.assign(result, errorChecker(result));

  return result;
};

/**
 * Aggregate JourneyMap
 */
export const updateProjectAnalysisDataJourneyMap = data => {
  return (dispatch, getState) => {
    const dataSplitByParticipant = chain(serialiseData(data).data)
      .groupBy(val => val.participant)
      .reduce((result, val, key) => {
        result.push(structureParticipantData(val, key));
        return result;
      }, [])
      .value();

    dispatch(setProjectAnalysisDataJourneyMap(dataSplitByParticipant));
  };
};

const setProjectAnalysisDataAggregateJourneyMap = aggregateJourneyMap => {
  return {
    type: SET_ANALYSIS_AGGREGATE_JOURNEYMAP_DATA,
    aggregateJourneyMap // is an array
  };
};

// ! TODO
export const updateProjectAnalysisDataAggregateJourneyMap = data => {
  return (dispatch, getState) => {
    const serialisedData = serialiseData(data);
    const structuredData = structureAggregateData(serialisedData);

    dispatch(setProjectAnalysisDataAggregateJourneyMap(structuredData));
  };
};

export const setProjectAnalysisDataCircumplex = circumplex => {
  return {
    type: SET_ANALYSIS_CIRCUMPLEX_DATA,
    circumplex
  };
};

export const updateProjectAnalysisDataCircumplex = data => {
  return (dispatch, getState) => {
    const yKey = d => d.Arousal; //
    const xKey = d => d.Valence_negative + -1 * d.Valence_negative;
    const sizeKey = d => d.Pupil; // Size of the dot
    const groupingKey = d => d.event;

    const isNumber = v => typeof v === 'number';
    // const minIntensityKey = d => d.Valence_negative;
    // const maxIntensityKey = d => d.Valence_positive;

    // const log = func => {
    //    return data => {
    //      console.log('jf-debug-> "log input": ', data);
    //      const out =  func(data);
    //      return out;
    //    }
    //  };

    const toAggregatedKeyPoint = (eventData, event) => {
      return {
        eventName: event,
        x: meanBy(eventData.filter(k => isNumber(xKey(k))), xKey),
        y: meanBy(eventData.filter(k => isNumber(yKey(k))), yKey),
        size: meanBy(eventData.filter(k => isNumber(sizeKey(k))), sizeKey)
        // intensity: meanBy(eventData.filter(k => typeof k[minIntensityKey] === 'number' && typeof k[maxIntensityKey] === 'number'), v => v[minIntensityKey] - v[maxIntensityKey]),
        // minX : minBy(eventData, xKey)
      };
    };
    const keepInterestingKeys = keepWhitelistedKeys(
      'event',
      'Arousal',
      'Pupil',
      'Valence_positive',
      'Valence_negative'
    );
    const groupByGroupinKey = partialRight(groupBy, groupingKey);
    const mapValuesToAggregatedKeyPoints = partialRight(mapValues, toAggregatedKeyPoint);
    const addMetadataProperties = serializedData => perEventKeyPoints => {
      const metadataProperties = {
        minSize: sizeKey(minBy(serializedData.data, sizeKey)),
        maxSize: sizeKey(maxBy(serializedData.data, sizeKey)),
        canItBeRender: true,
        keyNameError: false,
        dataError: false,

        minSizeRadius: 0.3,
        maxSizeRadius: 17,
        data: perEventKeyPoints
      };

      metadataProperties.sizeRange = metadataProperties.maxSize - metadataProperties.minSize;
      metadataProperties.sizeRadiusRange =
        metadataProperties.maxSizeRadius - metadataProperties.minSizeRadius;
      metadataProperties.sizeStep = metadataProperties.sizeRange / 6;
      metadataProperties.totalSizeRadius =
        metadataProperties.maxSizeRadius - metadataProperties.minSizeRadius;
      metadataProperties.totalSize = metadataProperties.maxSize - metadataProperties.minSize;

      return metadataProperties;
    };

    const serializedData = serialiseData(data);

    const perEventKeyPoints = compose(
      addMetadataProperties(serializedData),
      values,
      mapValuesToAggregatedKeyPoints,
      groupByGroupinKey,
      mapWith(keepInterestingKeys), // makes it easier to debug afterwards
      property('data')
    )(serializedData);

    // errorChecker(perEventKeyPoints);
    dispatch(setProjectAnalysisDataCircumplex(perEventKeyPoints));
  };
};



// WEBPACK FOOTER //
// ./src/scenes/analysis/data/analysis/analysisDataActions.js